import { finnhouseLogoUrl } from "./teamLogo";

const CASTERS_PATH = "casters";
const CASTERS_EXT = "webp";

/** Lowercase alphanumeric slug from display name (e.g. "Kari Grandi" → "karigrandi"). */
export const casterSlug = (name: string): string =>
  name
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "");

export const casterPhotoUrl = (name: string): string => {
  const slug = casterSlug(name);
  if (!slug) return finnhouseLogoUrl();

  return `${import.meta.env.VITE_S3_ASSET_URL}/${CASTERS_PATH}/${slug}.${CASTERS_EXT}`;
};

export const onCasterPhotoError = (event: React.SyntheticEvent<HTMLImageElement>): void => {
  const fallback = finnhouseLogoUrl();
  if (event.currentTarget.src !== fallback) {
    event.currentTarget.src = fallback;
  }
};
